export default __webpack_public_path__ + "static/media/fries.e68796e6.png";